<template>
	<b-container class="pt-4">
		<h1>Privatlivspolitik</h1>
		<h2>Generelt</h2>
		<p>Vi indsamler så vidt muligt kun de informationer om dig, som er nødvendige for at du kan bruge SkvizBiz. Det vil blandt andet være din email-adresse, dit CVR-nummer, og eventuelle oplysninger du selv indtaster i programmet.</p>
		<p>Der kan ske ændringer der gør det nødvendigt at opdatere denne privatlivspolitik. Hvis vi foretager ændringer, vil vi notere datoen for seneste ændring nederst i denne privatlivspolitik.
			<br>
		</p>
		<h2>Sikkerhed</h2>
		<p>Vi har truffet tekniske og organisatoriske foranstaltninger mod, at dine oplysninger hændeligt eller ulovligt bliver slettet, offentliggjort, fortabt, forringet eller kommer til uvedkommendes kendskab, misbruges eller i øvrigt behandles i strid med lovgivningen.
			<br>
		</p>
		<p>
			Hvis du opretter en SkvizBiz-konto og vælger at afsende emails gennem en gmail-konto, benyttes forbindelsen til google udelukkende til afsendelse af email. Der tilgås altså ingen data fra din gmail-konto, men SkvizBiz bruger udelukkende googles SMTP-server.
		</p>
		<h2>Formål</h2>
		<p>Oplysningerne bruges til at identificere dig som bruger, og tilbyde dig den service som programmet SkvizBiz udgør. Herudover anvender vi oplysninger om din brug af programmet til at optimere vores services, og til at yde dig den bedst mulige service. Det kan blandt andet involvere, at vi gennemgår din handlingslog for at kunne hjælpe dig til at bruge programmet endnu bedre i fremtiden.
			<br>
		</p>
		<h2>Periode for opbevaring</h2>
		<p>Vi opbevarer dine oplysninger så længe det er nødvendigt for at du kan bruge programmet SkvizBiz. Hvis du opsiger dit abonnement og beder os om at slette dine informationer gør vi det. Hvis vi har sendt dig fakturaer gemmer vi dog mindst dine faktureringsoplysninger i den periode som er påkrævet af aktuel lovgivning.</p>
		<h2>Videregivelse af oplysninger</h2>
		<p>Data om din brug af programmet SkvizBiz videregives ikke til andre end de medarbejdere der er hyret af SkvizBiz ApS til at yde kundesupport eller udvikle programmet. Vi er omhyggelige med ikke at videregive dine informationer til andre end det allerhøjst er nødvendigt for at kunne yde dig den service som dit abonnement indebærer. Der er dog nogle services i programmet SkvizBiz, som kræver at vi videregiver begrænsede specifikke informationer til andre virksomheder (som f.eks. PBS-modulet, som kræver at vi videregiver dit konto- og CVR-nummer til Mastercard).
			<br>
		</p>
		<h2>Indsigt og klager</h2>
		<p>Du har ret til at få oplyst, hvilke personoplysninger, vi behandler om dig. Du kan desuden til enhver tid gøre indsigelse mod, at oplysninger anvendes. Du kan også tilbagekalde dit samtykke til, at der bliver behandlet oplysninger om dig. Hvis de oplysninger, der behandles om dig, er forkerte har du ret til at de bliver rettet eller slettet. Henvendelse herom kan ske til: mail@skvizbiz.dk. Hvis du vil klage over vores behandling af dine personoplysninger, har du også mulighed for at tage kontakt til Datatilsynet.</p>
		<p>Bemærk dog, at hvis du anmoder om at få slettet de oplysninger vi har om dig, vil vi ikke længere kunne tilbyde programmet SkvizBiz. I dette tilfælde vil vi ikke refundere en eventuel resterende periode af dit abonnement.</p>
		<h2>Udgiver</h2>
		<p>Programmet SkvizBiz stilles til rådighed af:
			<br>
			<br>SkvizBiz ApS
			<br>Dyrehavegårdsvej 17
			<br>6000 Kolding
			<br>Telefon: 7734 0917
			<br>Email: mail@skvizbiz.dk
			<br>
		</p>
	</b-container>
</template>

<script>
	import {
		BContainer
	} from "bootstrap-vue";

	export default {
		head: {
			titleTemplate: "%s - Privatlivspolitik"
		},
		components: {
			BContainer,
		},
	};
</script>
